import React from 'react'
import { useTranslation } from 'react-i18next'
import { NotificationEmpty } from '@/components/Icons'
import styles from './index.module.less'

const Empty: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.root}>
      <NotificationEmpty className={styles.empty} />
      <h4>{t('message.noNewMessageTitle')}</h4>
      <p>{t('message.noNewMessageContent')}</p>
    </div>
  )
}

Empty.displayName = 'Empty'
export default Empty
